import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';

@Component({
  name: 'CmgNoLoyaltyForYouModal',
})
export default class CmgNoLoyaltyForYouModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.noLoyaltyForYou.visible;
  }

  get logoUrl(): string {
    return this.$appStore.state.cms.images.logos.medallion.default;
  }

  get faqUrl(): string {
    return this.$services.config.getFaqUrl();
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }
  
  close(): void {
    this.$services.ui.setModalVisibility('noLoyaltyForYou', false);
  }
}
